import { defineMessages } from 'react-intl';

export default defineMessages({
    requests: {
        defaultMessage: 'Requests',
        description: 'Requests header in avatar drop-down menu',
        id: 'sd.customerview.profile.dropdown.menu.v2.header.requests.non-final',
    },
    profile: {
        defaultMessage: 'Profile',
        description: 'Profile header in avatar drop-down menu',
        id: 'sd.customerview.profile.dropdown.menu.v2.header.profile.non-final',
    },
    logout: {
        defaultMessage: 'Sign out',
        description: 'Log out link in avatar drop-down menu',
        id: 'sd.customerview.profile.dropdown.menu.v2.logout.non-final',
    },
    topic: {
        defaultMessage: 'Topics and Portals',
        description: 'Topics and Portals in avatar drop-down menu',
        id: 'sd.customerview.profile.dropdown.menu.v2.topic.non-final',
    },
    look: {
        defaultMessage: 'Look and feel',
        description: 'look and feel in avatar drop-down menu',
        id: 'sd.customerview.profile.dropdown.menu.v2.look.non-final',
    },
    announcement: {
        defaultMessage: 'Announcements',
        description: 'announcement in avatar drop-down menu',
        id: 'sd.customerview.profile.dropdown.menu.v2.announcement.non-final',
    },
    signIn: {
        defaultMessage: 'Sign in message',
        description: 'sign in message link in avatar drop-down menu',
        id: 'sd.customerview.profile.dropdown.menu.v2.signIn.non-final',
    },
    tooltip: {
        defaultMessage: 'Your Profile and Settings',
        description: 'tooltip on avatar',
        id: 'sd.customerview.profile.v2.tooltip.non-final',
    },
    reporting: {
        defaultMessage: 'Reporting',
        description: 'Navigates to Reporting page',
        id: 'sd.customerview.profile.dropdown.menu.v2.reporting.non-final',
    },
    portalAnnouncement: {
        defaultMessage: 'Announcement',
        description: 'Navigates to Announcement page',
        id: 'sd.customerview.profile.dropdown.menu.v2.portalAnnouncement.non-final',
    },
    portalRequestTypeGroup: {
        defaultMessage: 'Request Type Group',
        description: 'Navigates to Request group page',
        id: 'sd.customerview.profile.dropdown.menu.v2.requestTypeGroup.non-final',
    },
    portal: {
        defaultMessage: 'Portal',
        description: 'Portal section heading',
        id: 'sd.customerview.profile.dropdown.menu.v2.portal.section.non-final',
    },
});
